export default __webpack_public_path__ + "static/media/bodyandspiritwrack2.5a2756c3.png";